
import { AppActions } from "../../types";
import { GET_NODEL, SET_NODEL_DATA } from "types/actions/nodelMaster.action";
import { NodelMasterData } from "types/models/nodelMaster/NodelMasterApp";
export enum VIEW_TYPE {
  LIST = 1,
  GRID = 2,
}

const initialState: {
  currentNodel: NodelMasterData | null;
  nodel: NodelMasterData[];
  nodelCount: number;
 
} = {
  currentNodel: null,
  nodel: [],
  nodelCount: 0,
  
};

const NodelMaster = (state = initialState, action: AppActions) => {
  switch (action.type) {
    case GET_NODEL:
      return {
        ...state,
        nodel: action.payload.data,
        nodelCount: action.payload.total,
      };
    case SET_NODEL_DATA:
      return {
        ...state,
        currentNodel: action.payload,
      };
    default:
      return state; 
  }
};

export default NodelMaster;
